import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const BarLineChart = props => (
  <SvgIcon width="16.203" height="16.275" viewBox="-2 -2 20.203 20.275" {...props}>
    <g id="Group_4279" data-name="Group 4279" transform="translate(-99.788 -144)">
      <g id="bar-chart" transform="translate(99.788 144)">
        <g id="Group_2581" data-name="Group 2581" transform="translate(0)">
          <g id="Group_2580" data-name="Group 2580">
            <path id="Path_2533" data-name="Path 2533" d="M45.583,0a1.622,1.622,0,0,0-1.62,1.62,1.6,1.6,0,0,0,.326.964L41.645,5.452a1.57,1.57,0,0,0-1.28.222L38.481,4.261a1.6,1.6,0,0,0,.081-.48,1.62,1.62,0,1,0-3.241,0,1.6,1.6,0,0,0,.081.48L33.517,5.674a1.687,1.687,0,1,0,.643.868l1.884-1.413a1.612,1.612,0,0,0,1.794,0l1.884,1.413a1.6,1.6,0,0,0-.081.48,1.62,1.62,0,0,0,3.241,0,1.6,1.6,0,0,0-.326-.964L45.2,3.19a1.6,1.6,0,0,0,.384.051,1.62,1.62,0,1,0,0-3.241Z" transform="translate(-31)" />
          </g>
        </g>
        <g id="Group_2583" data-name="Group 2583" transform="translate(4.321 8.642)">
          <g id="Group_2582" data-name="Group 2582">
            <path id="Path_2534" data-name="Path 2534" d="M153.7,240h-2.16a.54.54,0,0,0-.54.54v7.093h3.241V240.54A.54.54,0,0,0,153.7,240Z" transform="translate(-151 -240)" />
          </g>
        </g>
        <g id="Group_2585" data-name="Group 2585" transform="translate(8.642 10.802)">
          <g id="Group_2584" data-name="Group 2584">
            <path id="Path_2535" data-name="Path 2535" d="M273.7,300h-2.16a.54.54,0,0,0-.54.54v4.933h3.241V300.54A.54.54,0,0,0,273.7,300Z" transform="translate(-271 -300)" />
          </g>
        </g>
        <g id="Group_2587" data-name="Group 2587" transform="translate(12.962 6.481)">
          <g id="Group_2586" data-name="Group 2586">
            <path id="Path_2536" data-name="Path 2536" d="M393.7,180h-2.16a.54.54,0,0,0-.54.54v9.254h3.241V180.54A.54.54,0,0,0,393.7,180Z" transform="translate(-391 -180)" />
          </g>
        </g>
        <g id="Group_2589" data-name="Group 2589" transform="translate(0 11.882)">
          <g id="Group_2588" data-name="Group 2588">
            <path id="Path_2537" data-name="Path 2537" d="M33.7,330H31.54a.54.54,0,0,0-.54.54v3.853h3.241V330.54A.54.54,0,0,0,33.7,330Z" transform="translate(-31 -330)" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default BarLineChart;
